import { getUserEmail } from "../getUserEmail";

/** Последний показанный прогресс проценки подбора: «finished из total». */
export interface SelectionProgressSnapshot {
  total: number;
  finished: number;
}

// Прогресс храним ПО ПОЛЬЗОВАТЕЛЯМ (как цели подбора): после F5 список закупок
// приходит со stale gs_data (часто 0/0), и без снимка полоса прогресса
// «сбрасывается» до первого live-опроса GS.
const BASE_KEY = "eplex-selection-progress";

function getKey(): string {
  const email = getUserEmail();
  return email ? `${BASE_KEY}.${email}` : BASE_KEY;
}

export function getSavedSelectionProgress(): Record<string, SelectionProgressSnapshot> {
  try {
    const raw = localStorage.getItem(getKey());
    return raw ? (JSON.parse(raw) as Record<string, SelectionProgressSnapshot>) : {};
  } catch (error) {
    console.error("Failed to read selection progress: ", error);
    return {};
  }
}

export function saveSelectionProgress(map: Record<string, SelectionProgressSnapshot>): void {
  try {
    localStorage.setItem(getKey(), JSON.stringify(map));
  } catch (error) {
    console.error("Failed to save selection progress: ", error);
  }
}
